<script>
import IconProfile from '@/components/icon/IconProfile.vue';
import IconExit from '@/components/icon/IconExit.vue';
import { deleteToken } from '@/scripts/token.js';
import constants from '@/constants/index.js';

export default {
    data() {
        return {
            constants: constants,
        };
    },
    components: {
        IconProfile: IconProfile,
        IconExit: IconExit,
    },
    computed: {
        getEmail() {
            return this.$store.getters.USER_EMAIL;
        },
        getRole() {
            return this.$store.getters.USER_ROLE;
        },
    },
    methods: {
        async logout() {
            await deleteToken();
            await this.$store.dispatch('LOGOUT_USER');
            this.$router.push({
                name: constants.ROUTER_NAME.AUTHORIZATION,
            });
        },
    },
};
</script>

<template>
    <div class="user_container">
        <div class="user_icon">
            <IconProfile iconWidth="26px" iconHeight="26px" />
        </div>
        <div class="user_label">
            <label>{{ getEmail }}</label>
            <label>{{ getRole }}</label>
        </div>
    </div>
    <div class="button_container">
        <button
            class="cursor_pointer_label user_profile_button"
            @click="logout"
        >
            <label>Logout</label>
            <IconExit class="ml_5" iconWidth="12px" iconHeight="12px" />
        </button>
        <router-link
            class="cursor_pointer_label user_profile_button"
            :to="{ name: constants.ROUTER_NAME.SETTING }"
        >
            <label>Admin UI Settings</label>
        </router-link>
        <router-link
            class="cursor_pointer_label user_profile_button"
            :to="{ name: constants.ROUTER_NAME.SYSTEMSETTINGS }"
        >
            <label>System Settings</label>
        </router-link>
    </div>
</template>

<style scoped>
/* Controll */
.button_container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 5px;
    margin-left: 10px;
}
.user_profile_button {
    width: 180px;
    height: 26px;

    color: var(--left-button-text);
    background-color: var(--left-button);
    border: var(--border);
    border-radius: 5px;
    margin-bottom: 10px;

    font-family: Verdana, Geneva, Tahoma, sans-serif;
}
.user_profile_button:hover {
    background-color: var(--left-button-hover);
}
a.user_profile_button {
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
}

/* User */
.user_container {
    padding: 10px;
    padding-bottom: 0px;
    display: flex;
}
.user_icon {
    flex: 0 0 26px;
    color: #ffffff;
}
.user_label {
    width: 50px;
    flex: 0 1 149px;
    margin-left: 5px;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    font-size: 10px;
    color: #ffffff;
}
</style>
